<template>
  <div class="pagenotfound">
    <div class="container-404">
      <img src="/img/oops.png" alt="">
      <p>Oops il semblerait que cette page n'existe pas.</p>
      <router-link to="/" class="blue">Retour</router-link>

    </div>
  </div>
</template>

<script>
import {store} from "../store/store";

export default {
  name: 'pagenotfound',
  data() {
    return {}
  },
  methods: {},
  mounted() {
  }
}
</script>

<style scoped>

.pagenotfound {
  padding: 0 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

}

.container-404 {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  padding: 20px;
}

.container-404 img {
  width: 50%;
  margin: 20px;
}


.blue {
  text-transform: uppercase;
  margin: 50px;
  padding: 10px;
  border-radius: 10px;
  font-family: var(--main-title-font);
  font-size: 26px;
  width: 70%;
  text-align: center;
  border: 2px solid #FFF;
  font-weight: bold;
  background: linear-gradient(#00CDF8, #00ABDD);
  transition: .3s;
}

.blue:hover {
  color: #00CDF8;
  border: 2px solid #00CDF8;

  background: #fff;

}

@media screen and (min-width: 780px) {
  .pagenotfound {

  }
}

</style>
